import $ from 'jquery';
import { defaultsDeep, isNil } from 'lodash';
import { render as renderLocationWidget } from '@dealersites/location-widget';
import { LocationStorage } from '@dealer/components/location-storage';

const lastSelectedLocation = LocationStorage.get();

// Common Widget Options
const sharedOptions = {
  api: { baseUrl: '', path: '/api/locationsearch', params: { province_code: 'ON' } },
  autoLocate: false,
  search: {
    inputPlaceholder: 'All Locations',
    attributes: {
      autoComplete: 'off',
    },
  },
  radius: { enabled: false },
  showOtherResults: false,
};

const sharedTheme = {
  search: {
    inputBase: '',
    results: {
      wrapper: 'z-20',
      container: '!h-auto',
    },
  },
};

// Set up mini search refresh support for the location filter.
let searchMiniWidget = null;
document.addEventListener('inventory_search_mini_setup', (e) => {
  searchMiniWidget = e.searchMini;
  searchMiniWidget.values.city = '';
  searchMiniWidget.values.location = '';
});

$(document).ready(function () {
  // Homepage Location Widget
  const homeWidgetRoot = document.getElementById('home-location-widget-root');
  if (homeWidgetRoot && window.ocIsHomepage) {
    renderLocationWidget({
      rootElementId: homeWidgetRoot.id,
      options: defaultsDeep(
        {
          autoLocate: !lastSelectedLocation,
          initialLocation: lastSelectedLocation,
          search: {
            inputPlaceholder: homeWidgetRoot.dataset.placeholder,
          },
          inputNames: {
            combinedLatLong: 'dsp_location',
          },
          onSelectLocation: (location) => {
            LocationStorage.set(location);

            if (!searchMiniWidget) {
              return;
            }

            let coordinates = location?.coordinates?.searchValue() ?? '';
            if (searchMiniWidget.values.location !== coordinates) {
              searchMiniWidget.values.location = coordinates;
              searchMiniWidget.fetchMakesAndModels();
            }
          },
        },
        sharedOptions,
      ),
      theme: defaultsDeep(
        {
          search: {
            input: 'field flex-1',
          },
        },
        sharedTheme,
      ),
    });
  }

  // SRP Location Widget
  const srpWidgetRoot = document.getElementById('location-widget-root');
  if (srpWidgetRoot) {
    const hasLocationFilterValue = !isNil(new URL(location.href).searchParams.get('dsp_location'));
    renderLocationWidget({
      rootElementId: srpWidgetRoot.id,
      options: defaultsDeep(
        {
          initialLocation: hasLocationFilterValue ? lastSelectedLocation : undefined,
          search: {
            inputPlaceholder: srpWidgetRoot.dataset.placeholder,
          },
          inputNames: {
            combinedLatLong: 'dsp_location',
          },
          onSelectLocation: (location) => {
            LocationStorage.set(location);
          },
        },
        sharedOptions,
      ),
      theme: sharedTheme,
    });

    srpWidgetRoot.handleChangeEvent = (changeEventName, { location }, filter) => {
      // Only the location change has useful information.
      if (changeEventName !== 'location_change') {
        return;
      }

      if (location?.coordinates) {
        filter.changeValue(location.coordinates.searchValue());
      }
    };
  }

  // DealerSearch Location Widget
  const dsWidgetRoot = document.getElementById('dealer-search-location-widget-root');
  if (dsWidgetRoot) {
    renderLocationWidget({
      rootElementId: dsWidgetRoot.id,
      options: defaultsDeep(
        {
          search: {
            initialValue: new URL(location.href).searchParams.get('dsp_dealer_city'),
            inputPlaceholder: dsWidgetRoot.dataset.placeholder,
          },
          inputNames: {
            city: 'dsp_dealer_city',
          },
        },
        sharedOptions,
      ),
      theme: defaultsDeep(
        {
          search: {
            input: 'field flex-1',
          },
        },
        sharedTheme,
      ),
    });
  }
});
